import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import LoginModule from "./modules/LoginModule";

import AppModule from "./modules/appModule";
import VendorModule from "./modules/VendorsModule";
import VendorCommoditiesModule from "./modules/VendorCommoditiesModule";
import CommodityModule from "./modules/CommodityModule";
import UploadPrices from "./modules/UploadPricesModule";

import CommissionModule from "./modules/CommissionModule";

import UserModule from "./modules/UserModule";
import BankCommodities from "./modules/BankCommoditiesModule";
import Documents from "./modules/DocumentsModule";
import CompletedRequest from "./modules/CompletedRequestModule";
//request
import BuyRequestModule from "./modules/BuyRequestModule";
import ResetModule from "./modules/ResetPasswordModule";
import MISReport from "./modules/MISModule";
const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    LoginModule,
    AppModule,
    Vendors: VendorModule,
    VendorCommoditiesModule: VendorCommoditiesModule,
    CommodityModule: CommodityModule,
    UploadPrices: UploadPrices,
    CommissionModule: CommissionModule,
    UserModule: UserModule,
    BuyRequestModule: BuyRequestModule,
    BankCommodities: BankCommodities,
    Documents: Documents,
    CompletedRequest: CompletedRequest,
    ResetModule: ResetModule,
    MISReport
  },
  strict: debug
});
